module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/shield-user-0cda1c2c4cb5a444feb298a08d78a47c.svg";